<template>
  <div class="cell-container">
   <!-- <div>
      <img src="" />
    </div>
    <div>
      <div>英语口语能力人工智能分级测评（学生端）</div>
      <div>
        针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。针对湖北地区的新老客户...
        使用简介 第一步：下载并安装E听说中学(先关闭杀毒软件和安全卫士避免误杀)
        第二步：注册并登录E听说中学(请使用手机号码注册并登录)
        第三步：在“我的E卡”手动添加E卡，输入E卡号和密码，完成添加
        提示：“练习”栏目可以添加老师和班级
      </div>
      <div><span>电脑端下载</span><span>手机端下载</span></div>
      <div>温馨提示</div>
    </div>-->
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.cell-container {
  padding:100px;
  // border: solid 1px #dedfe1;
  // width: 1168px;
  // fbackground-color: #ffffff;
  // border-radius: 10px;
  // margin:20px auto;
}
</style>
